import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { AuthService } from '../../../service/auth.service';
import { UserInterface, Documento } from '../../../models/user';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  Documentos: Documento[] = [];
  flagDocumentoCuenta: any;
  flagDocumentoHac: any;
  flagDocumentoDomicilio: any;
  flagDocumentoActa: any;
  flagDocumentoINE: any;
  flagBoton: any;
  urlDocument: Observable<string>;
  constructor( private authService: AuthService, public db: AngularFirestore, private storage: AngularFireStorage) { }
  user: UserInterface = {
    username: '',
    email: '',
    // photoUrl: '',
    roles: {},
    geolocalizacion: {}
  };
  uidUser: string = null;
  public usuario: any = {};

    public providerId: string = 'null';
  ngOnInit() {
    this.authService.isAuth().subscribe(user => {
      if (user) {
       this.uidUser = this.user.uid = user.uid;
       this.user.username = user.displayName;
       this.user.email = user.email;
       this.user.photourl = user.photoURL;
       this.providerId = user.providerData[0].providerId;
       this.db.doc(`users/${this.uidUser}`).valueChanges().subscribe( data => {
       this.flagBoton = true;
       this.usuario = data;
          console.log('usuer', this.usuario);
          if(this.usuario.docNumeroCuenta == undefined || this.usuario.docNumeroCuenta == null){
            this.flagDocumentoCuenta = false;
            this.flagBoton = false;
          }else{
            this.flagDocumentoCuenta = true;
          }
          if(this.usuario.docHacienda == undefined || this.usuario.docHacienda == null){
            this.flagDocumentoHac = false;
            this.flagBoton = false;
          }else{
            this.flagDocumentoHac = true;
          }
          if(this.usuario.docDomicilio == undefined || this.usuario.docDomicilio == null){
            this.flagDocumentoDomicilio = false;
            this.flagBoton = false;
          }else{
            this.flagDocumentoDomicilio = true;
          }
          if(this.usuario.docActa == undefined || this.usuario.docActa == null){
            this.flagDocumentoActa = false;
            this.flagBoton = false;
          }else{
            this.flagDocumentoActa = true;
          }
          if(this.usuario.docINE == undefined || this.usuario.docINE == null){
            this.flagDocumentoINE = false;
            this.flagBoton = false;
          }else{
            this.flagDocumentoINE = true;
          }
        });
        

        }
    });
  }

  
  getFile(e, tipo){ //obtiene los archivos cargados
    console.log('subir', e.target.files[0]);
    const id = Math.random().toString(36).substring(2);
    const file = e.target.files[0];
    const filePath = `datosSatCuenta/${this.usuario.username}_${tipo}_${id}`;
    let Documento : Documento = {
      file: file,
      filePath: filePath,
      DownloadURLDoc: '',
      tipo: tipo
    }
    this.Documentos.push(Documento);

  }
  uploadFiles(){ //subida de archivos, si y solo si no existe aun ninguno en ya cargado en firebase
    const userRef: AngularFirestoreDocument<any> = this.db.doc(
      `users/${this.usuario.uid}`
    );
    console.log("enviando archivos");
    if(this.Documentos.length > 0){
    this.Documentos.forEach( doc => {
      const ref = this.storage.ref(doc.filePath);
      const task = this.storage.upload(doc.filePath, doc.file);
      task.snapshotChanges().pipe(finalize(() =>
        ref.getDownloadURL().subscribe( r => {
          doc.DownloadURLDoc=this.urlDocument = r;
          console.log('URL', r);
          console.log("Archivo subido", doc.DownloadURLDoc);
          if (doc.tipo == 'numeroCuenta'){
            const data = {
              docNumeroCuenta: doc.DownloadURLDoc
            }
            userRef.set(data, { merge: true });
          }
          if (doc.tipo == 'docHacienda'){
            const data = {
              docHacienda: doc.DownloadURLDoc
            }
            userRef.set(data, { merge: true });
          }
          if (doc.tipo == 'docDomicilio'){
            const data = {
              docDomicilio: doc.DownloadURLDoc
            }
            userRef.set(data, { merge: true });
          }
          if (doc.tipo == 'docINE'){
            const data = {
              docINE: doc.DownloadURLDoc
            }
            userRef.set(data, { merge: true });
          }
          if (doc.tipo == 'docActa'){
            const data = {
              docActa: doc.DownloadURLDoc
            }
            userRef.set(data, { merge: true });
          }
          console.log("Archivo subido", doc.DownloadURLDoc);
        })
      )
    )
    .subscribe();
    }); ///guardar url en campo en la tabla convenios, separandolo en SAT y numero de cuenta
    console.log("Archivos enviados", this.Documentos);
  }
    else{
      console.log("Archivos incompletos");
    }
  }
}
